import React from "react";
import styled from "styled-components";
import { Link, withRouter } from "react-router-dom";
import { ContainerWrapper, NavStrip, HelmetTitle } from "../../../Components/Utils";
import { tikiGet } from "./";
import Layout from "../../../Components/Layout";
import Navigation from "../../BannerItems/Components/Navigation";

const FlexStart = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
`;

const PartnerStyle = styled(FlexStart)`
  border: 1px solid hsla(217,35%,35%,.5);
  background-color: white;
  margin: 10px;
  overflow: auto;
  padding: 1rem;
  text-align: left;
  width: 500px;
  display: flex;
  flex-direction: column;
`;
const PartnerBodyStyle = styled(FlexStart)`
  flex-direction: column;
  font-size: 93%;
  position: relative;
  max-height: 700px;
  overflow-y: auto;
  word-break: break-word;
  transition: all .3s ease-in-out;
  p {
    margin: .6rem 0;
    line-height: 32px;
  }
  small {
    display: block;
  }
  a { font-size: 93%; }
`;
const myDot2 = {
  margin: ".2rem 0"
}
const btnStyle = {
  cursor: "pointer",
  border: "none",
  fontSize: ".85rem",
  padding: "5px 7px",
}
class PartnershipList extends React.Component {
  constructor(props) {
    super(props);
    this.state = { partnership: []};
    this.handleReadMore = this.handleReadMore.bind(this);
  }
  componentDidMount() {
    window.scrollTo(0,0);
    return tikiGet('partnership', this);
  }

  handleReadMore(e) {
    console.log('From handle read more', e.target.value);
    if (e.target.value) {
      const clickedVal = e.target.value.slice(-1);
      const introfor = document.getElementById(`intro${clickedVal}`);
      const partnrBtn = document.getElementById(e.target.value)
          
      if (introfor.style.display === "none") {
        introfor.style.display = "block";
        partnrBtn.innerText = "Lessen <<";
      }
      else {
        introfor.style.display = "none";
        partnrBtn.innerText = "Read more >>";
      }

      // (introfor.style.display === "none") ? introfor.style.display = "block": introfor.style.display = "none";
    }
    
  }
  render() {
  
    const pd = this.state.partnership;
    console.log("testing pd..", pd);
    return (
      <div className="App">
        <HelmetTitle title="Partnership" />
        <Layout 
          head={
            <React.Fragment>
              <Navigation />
              <NavStrip />
            </React.Fragment>
          }
          body={
            <ContainerWrapper textAlign="justify">
            <h3 className="banner-item__header">Calls for partnerships</h3>
            <p>The ventures below are interested in building partnerships with Canadian organizations so as to enhance their transnational opportunities. The descriptions below provide a brief summary of the ventures’ value proposition, their specific ask, some ancillary information, and finally contact information.</p>

            <div style={{display:"flex", flexWrap: "wrap"}}>
              {
                pd && pd.map((p, index) => (
                  <PartnerStyle key={p.thisId}>
                    <PartnerBodyStyle>
                      <h4 style={{color: "hsl(217,40%,35%)", margin: "0"}} dangerouslySetInnerHTML={{__html: p.company}} />
                      {
                        p.partnershipCall && p.partnershipCall.map((partner, index) => (
                          <div key={index}>
                            <p style={{fontWeight: "600", myDot2}}>{partner.partnershipName}</p>
                            <p style={myDot2} dangerouslySetInnerHTML={{__html: partner.partnershipDescription}} />
                          </div>
                        ))
                      }
                      <p id={`intro${index}`} style={{display: "none"}} dangerouslySetInnerHTML={{__html: p.introduction}} />
                      <p style={myDot2}>Contact:</p>
                      <p style={myDot2} dangerouslySetInnerHTML={{__html: p.founder}} />
                      <p style={myDot2} dangerouslySetInnerHTML={{__html: p.email}} />
                      <p style={myDot2} dangerouslySetInnerHTML={{__html: p.phone}} />
                      <a href={p.website && `http://${p.website}`} target="_blank" rel="noopener noreferrer" alt={p.company}>{p.website}</a>
                    </PartnerBodyStyle>
                    <div className="pt-3 w-100 d-flex">
                      <button id={`partnr${index}`} value={`partnr${index}`} style={btnStyle} onClick={this.handleReadMore}>Read more >></button>
                    </div>
                    
                  </PartnerStyle>
                ))
              }
            </div>
          </ContainerWrapper>
          }
        />
      </div>
      
    );
  }
}

export default withRouter(PartnershipList)



// WEBPACK FOOTER //
// ./src/Pages/Experiences/Alumni/Partnerships.js